import { useEffect, useRef, useState } from "react";

/** Smoothly counts up to `target` over `duration` ms using rAF. Deterministic end value. */
export function useCountUp(target, duration = 1500, start = true) {
  const [value, setValue] = useState(0);
  const rafRef = useRef();

  useEffect(() => {
    if (!start) return;
    let startTime;
    const step = (ts) => {
      if (startTime === undefined) startTime = ts;
      const progress = Math.min((ts - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setValue(Math.round(eased * target));
      if (progress < 1) rafRef.current = requestAnimationFrame(step);
    };
    rafRef.current = requestAnimationFrame(step);
    return () => cancelAnimationFrame(rafRef.current);
  }, [target, duration, start]);

  return value;
}
